// extracted by mini-css-extract-plugin
export default {"inputDescription":"KaiAssistantForm_inputDescription__qsrPC"};